import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import { WidgetContext } from 'src/modules/App/WidgetContext'
import { isFeatureUsed, isChatCurrentlyEnabled, getInternalFeatureUrl } from 'src/utils/features'
import Storage from 'src/utils/storage'

// TODO: Figure out how to use "react-loadable"  (now @loadable/component)
//  or to import functions which import components (like for Payments)

import Login from 'src/modules/Auth/Email'
import Quotes from 'src/modules/Quotes/Quote.container'
import Documents from 'src/modules/Documents/MyDocuments.container'
// import ClaimsForm from 'src/modules/Claims/Claims.container'
import ClaimsType from 'src/modules/Claims/ClaimType'
// import Inventory from 'src/modules/Inventory/Groups/Groups.container'
// import Services from 'src/modules/Services'

import { logError, isLoggedIn } from 'src/utils/helpers'

class Home extends Component {
  constructor(props) {
    super(props)

    const { openSidebar } = props

    if (typeof openSidebar === 'function') {
      openSidebar()
    }
  }

  state = {
    feature: null,
  }

  componentDidMount() {
    const {
      history,
      closeSidebar,
      setCurrentlyOpenFeature,
      isChatOnlyFeature,
      features,
      chat,
      chatOptions,
      isAfterHours,
      isChatEmpty,
      initialWidgetFeature,
      isWidget,
    } = this.props

    const isChatEnabled = isChatCurrentlyEnabled(chat, chatOptions, isAfterHours, isChatEmpty)

    // Redirect to widget feature only on first load/render
    if (
      history &&
      isWidget &&
      typeof initialWidgetFeature === 'string' &&
      Storage.getSessionItem('isInitialWidgetFeatureLoaded') !== '1'
    ) {
      // Try to open only available features
      const url = getInternalFeatureUrl(features, initialWidgetFeature)

      if (url) {
        if (url === '/chat' && !isChatEnabled) {
          logError('Should load Chat but it is not available (e.g. after hours).', null, 0)
        } else {
          setCurrentlyOpenFeature(initialWidgetFeature)
          closeSidebar()

          // To prevent redirecting on consequent loads
          Storage.setSessionItem('isInitialWidgetFeatureLoaded', '1')

          history.replace(url)
          return true
        }
      } else {
        logError('Could not find feature URL', null, 0)
      }
    }

    // If only chat is used redirect to /chat
    if (isChatOnlyFeature) {
      // Exit if Chat is disabled
      if (!isChatEnabled) {
        return false
      }

      setCurrentlyOpenFeature('chat')

      closeSidebar()

      if (history) {
        history.replace('/chat')
        return true
      }
    }

    // Return first feature we can use for home page
    const feature = features.find(f => isFeatureUsed(f.id, features))
    // Do not render anything if feature not found
    if (!feature) {
      return false
    }

    this.setState({
      feature: feature,
    })
  }

  requiresLogin = feature => {
    const { user } = this.props

    if (!feature.settings.isLoginRequired) {
      return false
    }

    // If not logged in and feature requires login
    return !isLoggedIn(user)
  }

  render() {
    const { claimSettings, history } = this.props
    const { feature } = this.state
    if (!feature) {
      console.log(feature)
      if (history) {
        history.replace('/welcome')
        return true
      }
    }

    const name = feature.id

    if (this.requiresLogin(feature)) {
      return <Login useDefaultDocumentTitle={true} disableLoggedInRedirect={true} />
    }
    if (name === 'requestQuote') {
      return <Quotes useDefaultDocumentTitle={true} />
    }
    if (name === 'documents') {
      return <Documents useDefaultDocumentTitle={true} />
    }
    if (name === 'reportClaim') {
      const showClaimNumbers =
        claimSettings.hasOwnProperty('showClaimNumbers') && claimSettings.showClaimNumbers === true
      if (showClaimNumbers === true) {
        return <ClaimsType />
      } else {
        // TODO: PAT-3383 Enable when preventing disclaimer to show if Report a Claim is first enabled feature on mobiel/widget
        // return <ClaimsForm showDisclaimer={true} />
      }
    }
    // TODO: PAT-3298 Fix loading Home Inventory (and Road Services) when it's first enabled feature
    // if (name === 'inventory') {
    //   return <Inventory />
    // }
    // if (name === 'services') {
    //   return <Services />
    // }
    return ''
  }
}

const HomeContext = props => (
  <WidgetContext.Consumer>{context => <Home {...props} {...context} />}</WidgetContext.Consumer>
)

export default withRouter(HomeContext)
